import { createSelector } from 'reselect'

import { RootState } from '~store/root.reducer'

const selectNewUserFormState = (state: RootState) => state.newUserWizard

/**
 * get Data of New System Integrator Form
 */
export const getNewUserFormData = createSelector(
  (state: RootState) => state.newUserWizard.data,
  data => data,
)

/**
 * get Current Step of New System Integrator Form
 */
export const getNewUserFormCurrentStep = createSelector(
  selectNewUserFormState,
  state => state.currentStep,
)
